import { applyMiddleware, compose, createStore, Store } from "redux"
import { History } from "history"
import { routerMiddleware } from "connected-react-router"
import thunk from "redux-thunk"
import { State, MainAction, rootReducer } from "../Reducers"
import { TrackerMiddleware } from "../Middleware/Tracker"
import { NetworkType, ClientType } from "../Actions/Types"

/**
 * This will setup everything for running redux/routing and devtools
 * @param preloadedState provide old state if available (used in hot reloading)
 */
export function configureStore(history: History<any>) {
    return function loadStore(preloadedState?: any): Store<State, MainAction> {
        // Create reducer for redux
        const reducer = () => rootReducer(history)
        const middleware = [thunk, routerMiddleware(history)]
        if (
            process.env.JEST_WORKER_ID === undefined &&
            process.env.NODE_ENV !== "test"
        ) {
            middleware.push(TrackerMiddleware())
        }
        const middlewareEnhancer = applyMiddleware(...middleware)
        const composeEnhancer: typeof compose = (window as any)
            .__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
            ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                  trace: true,
                  actionsBlacklist: [
                      NetworkType.setDebounceState,
                      NetworkType.setPollState,
                      ClientType.inputRender_change
                  ]
              }) || compose
            : compose
        const composedEnhancers = composeEnhancer(middlewareEnhancer)
        const store = createStore(reducer(), preloadedState, composedEnhancers)

        if (process.env.NODE_ENV !== "production" && (module as any).hot) {
            ;(module as any).hot.accept("../Reducers", () =>
                store.replaceReducer(reducer())
            )
        }

        return store
    }
}
